const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowTopRight(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    transform: "translate(0.5)",
    fill: "white",
    fillOpacity: 0.01,
    style: {
      fill: "white",
      fillOpacity: 0.01
    }
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.41721 9.0829C3.26099 8.92666 3.26099 8.67338 3.41721 8.51722L8.73437 3.20002H5.30005C5.07914 3.20002 4.90005 3.02094 4.90005 2.80002C4.90005 2.57911 5.07914 2.40002 5.30005 2.40002H9.70005C9.80613 2.40002 9.90789 2.44217 9.98293 2.51718C10.0579 2.5922 10.1001 2.69394 10.1001 2.80002V7.20003C10.1001 7.42094 9.92093 7.60003 9.70005 7.60003C9.47917 7.60003 9.30005 7.42094 9.30005 7.20003V3.76571L3.98289 9.0829C3.82668 9.23906 3.57342 9.23906 3.41721 9.0829Z",
    fill: "#000713",
    fillOpacity: 0.624,
    style: {
      fill: "#000713",
      fill: "color(display-p3 0.0008 0.0256 0.0752)",
      fillOpacity: 0.624
    }
  }));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowTopRight);
export default __webpack_public_path__ + "static/media/arrow-top-right.83884d9504a23ab33a819cf5eb89e328.svg";
export { ForwardRef as ReactComponent };